import { useLang } from "../context/LangContext";
import ProjectsTimeline from "./ProjectsTimeline";

export default function Projects() {
  const { t, lang } = useLang();

  const topItems = t.projects.items.filter((item) => item.row === "top");
  const bottomItems = t.projects.items.filter((item) => item.row === "bottom");

  return (
    <ProjectsTimeline
      lang={lang}
      title={t.projects.title}
      subtitle={t.projects.sub}
      topItems={topItems}
      bottomItems={bottomItems}
      imageUrl={t.projects.imageUrl}
      imageAlt={t.projects.imageAlt}
    />
  );
}
